import { useEffect } from "react"
import { getDb } from "../lib/db"
import { initBranchAssignmentsReplication } from "../lib/replication/initBranchAssignmentsReplication"
import { useInstantAuth } from "../hooks/useInstantAuth"

let branchAssignmentsInitialized = false
let transactionReplicationMap = new Map()

export function AppInitializer() {
  const { business } = useInstantAuth()

  useEffect(() => {
    const init = async () => {
      try {
        const db = await getDb()
        
        // Initialize branch assignments replication once
        if (!branchAssignmentsInitialized) {
          await initBranchAssignmentsReplication(db)
          branchAssignmentsInitialized = true
          console.log("[Replication] Branch assignments replication initialized")
        }

        // Initialize revamp-related replications per business using a
        // tiered boot to reduce cold-start load and render local data fast.
        if (business?.id && !transactionReplicationMap.has(business.id)) {
          try {
            const dbModule = await import("../lib/db")

            // Tier 1 — needed for UI to render immediately
            try { dbModule.startBranchesReplication(db.branches, business.id) } catch (e) { console.error('startBranchesReplication failed', e) }
            try { dbModule.startProductsReplication(db.products, business.id) } catch (e) { console.error('startProductsReplication failed', e) }
            try { dbModule.startProductBranchPricingReplication(db.product_branch_pricing, business.id) } catch (e) { console.error('startProductBranchPricingReplication failed', e) }
            try { dbModule.startInventoryMovementsReplication(db.inventory_movements, business.id) } catch (e) { console.error('startInventoryMovementsReplication failed', e) }

            // Tier 2 — needed for dashboard and transactions (delay a bit)
            setTimeout(() => {
              try { dbModule.startSalesReplication(db.sales, business.id) } catch (e) { console.error('startSalesReplication failed', e) }
              try { dbModule.startExpensesReplication(db.expenses, business.id) } catch (e) { console.error('startExpensesReplication failed', e) }
              try { dbModule.startCustomersReplication(db.customers, business.id) } catch (e) { console.error('startCustomersReplication failed', e) }
              try { dbModule.startTransactionsReplication(db.transactions, business.id) } catch (e) { console.error('startTransactionsReplication failed', e) }
            }, 2000)

            // Tier 3 — background data (start later)
            setTimeout(() => {
              try { dbModule.startSaleItemsReplication(db.sale_items, business.id) } catch (e) { console.error('startSaleItemsReplication failed', e) }
              try { dbModule.startSalePaymentsReplication(db.sale_payments, business.id) } catch (e) { console.error('startSalePaymentsReplication failed', e) }
              try { dbModule.startStockEntriesReplication(db.stock_entries, business.id) } catch (e) { console.error('startStockEntriesReplication failed', e) }
              try { dbModule.startStockTransfersReplication(db.stock_transfers, business.id) } catch (e) { console.error('startStockTransfersReplication failed', e) }
              try { dbModule.startBranchFloatsReplication(db.branch_floats, business.id) } catch (e) { console.error('startBranchFloatsReplication failed', e) }
              try { dbModule.startStockTakesReplication(db.stock_takes, business.id) } catch (e) { console.error('startStockTakesReplication failed', e) }
              try { dbModule.startStockTakeItemsReplication(db.stock_take_items, business.id) } catch (e) { console.error('startStockTakeItemsReplication failed', e) }
              try { dbModule.startCreditAccountsReplication(db.credit_accounts, business.id) } catch (e) { console.error('startCreditAccountsReplication failed', e) }
              try { dbModule.startCreditRepaymentsReplication(db.credit_repayments, business.id) } catch (e) { console.error('startCreditRepaymentsReplication failed', e) }
              try { dbModule.startCustomersReplication(db.customers, business.id) } catch (e) { console.error('startCustomersReplication failed in tier3', e) }
            }, 8000)

            transactionReplicationMap.set(business.id, true)
            console.log("[Replication] Tiered revamp replications initialized for business:", business.id)
          } catch (replicationError) {
            console.error("[Replication] Failed to start revamp replications:", replicationError)
          }
        }
      } catch (err) {
        console.error("Failed to initialize replication:", err)
      }
    }

    init()
  }, [business?.id])

  return null
}
